import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";

import { usePlayground } from "@/components/Playground/playground-store";
import { usePlaceholderContainer } from "@/components/Playground/Messages/PlaceholderContainer/context/placeholder-container-context";
import MessageActions from "@/components/Playground/Messages/Message/MessageActions";
import RoleSelector from "@/components/Playground/Messages/Message/RoleSelector";
import { PlaceholderContainerHeaderDragHandle as DragHandle } from "@/components/Playground/Messages/PlaceholderContainer/Header/DragHandle";
import { PlaceholderContainerHeaderVariableNameInput as VariableNameInput } from "@/components/Playground/Messages/PlaceholderContainer/Header/VariableNameInput";

export const PlaceholderContainerHeader = observer(() => {
  const playground = usePlayground();
  const { message, readonly, childStore } = usePlaceholderContainer();

  const handleCopy = () => {
    const data = childStore.messages.map(msg => ({
      id: msg.id,
      role: msg.role,
      content: msg.rawContent.length > 0 ? msg.rawContent : [],
    }));

    navigator.clipboard.writeText(JSON.stringify(data));
  };

  const handleDelete = () => {
    runInAction(() => playground.deleteMessage(message.id));
  };

  return (
    <div className="flex items-center justify-between gap-x-2 pb-2">
      <div className="flex w-full items-center gap-x-2">
        <DragHandle />

        <RoleSelector selected="placeholder" onSelect={message.setRole} mode="batch" />

        <VariableNameInput />

        <div className="relative z-20 ml-auto flex gap-x-2">
          <MessageActions
            readonly={readonly}
            onCopy={handleCopy}
            onDelete={handleDelete}
            disabled={playground.isAIPromptAssistantLoading}
          />
        </div>
      </div>
    </div>
  );
});
